import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { useSEO } from "../hooks/useSEO";
import { Button } from "../components/ui/button";
import { USPs } from "../components/home/USPs";
import { ServicesPreview } from "../components/home/ServicesPreview";
import { Reviews } from "../components/home/Reviews";
import { LocationSection } from "../components/home/LocationSection";

export default function KapperUtrecht() {
  const { lang } = useLanguage();
  useSEO(
    lang === "nl"
      ? "Kapper in Utrecht | EliteTheBarber – Boek direct online"
      : "Barber in Utrecht | EliteTheBarber – Book online instantly",
    lang === "nl"
      ? "Op zoek naar een goede kapper in Utrecht? EliteTheBarber aan de Vlampijpstraat 75g biedt precisie knipbeurten, baard trimmen en meer. Boek eenvoudig online je afspraak."
      : "Looking for a great barber in Utrecht? EliteTheBarber on Vlampijpstraat 75g offers precision haircuts, beard grooming and more. Book your appointment online in seconds."
  );

  return (
    <div data-testid="kapper-utrecht-page">
      <section className="py-24 sm:py-32 px-4 sm:px-6 text-center bg-[#0A0A0A]">
        <div className="max-w-3xl mx-auto">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4">Utrecht &middot; Vlampijpstraat 75g</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white mb-6 tracking-tight">
            {lang === "nl" ? "Dé Kapper in Utrecht" : "The Barber in Utrecht"}
          </h1>
          <p className="text-white/60 text-base sm:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            {lang === "nl"
              ? "EliteTheBarber is jouw premium barbershop in het hart van Utrecht. Precisie knipbeurten, verzorgde baarden en een ervaring die klopt. Geen wachtrijen — boek online en kom op jouw moment binnen."
              : "EliteTheBarber is your premium barbershop in the heart of Utrecht. Precision haircuts, sharp beard grooming and an experience that fits. No queues — book online and walk in on your own time."}
          </p>
          <Link to="/boeken">
            <Button data-testid="kapper-utrecht-cta-button" className="bg-gold text-white hover:bg-gold-hover rounded-none px-10 py-6 text-base">
              {lang === "nl" ? "Boek nu je afspraak" : "Book your appointment now"}
            </Button>
          </Link>
        </div>
      </section>
      <USPs />
      <ServicesPreview />
      <Reviews />
      <LocationSection />
    </div>
  );
}
